import { memo } from "react"
import { Box, Button, Flex, Heading } from "@chakra-ui/react"
import { useRoutes } from "@app/hooks/useRoutes"
import { useStamped } from "@app/hooks/useStamped"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation, Pagination } from "swiper"
import { useMedia } from "@app/hooks/useMedia"
import { CustomLink } from "@components/Link"
import ReviewsItem from "@components/Sections/Reviews/ReviewsItem"

const Reviews: React.FC<GatsbyTypes.SanitySectionReviews> = ({ bgColor, heading, link }) => {
  const { isMedium } = useMedia()
  const { voted, reviews, submitVoteWithProductId } = useStamped({ productId: null, pageSize: 9, type: "reviews" })
  const { urlResolver } = useRoutes()
  const resolvedUrl = urlResolver(link)

  return (
    <Box bg={bgColor} pt={["35px", null, "169px"]} pb={["51px", null, "126px"]} pl={[0, null, "max(calc((100% - 1440px) / 2), 48px)"]}>
      <Flex flexDir={["column", null, "row"]}>
        <Box mb={[5, null, 0]} w={["100%", "500px"]} pos="relative" px={["21px", null, 0]} mr={[null, null, "70px"]}>
          <Heading size={["h3", null, "h2"]} _before={{ content: '"“"', pos: "absolute", right: "100%", display: ["none", null, "block"] }}>
            <Heading as="span" display={["inline-block", null, "none"]}>
              “
            </Heading>
            {heading}”
          </Heading>
          {resolvedUrl?.title && resolvedUrl?.url && (
            <CustomLink to={resolvedUrl?.url}>
              <Button variant="outline" mt={[5, null, 10]} w={["100%", "unset"]}>
                {resolvedUrl?.title}
              </Button>
            </CustomLink>
          )}
        </Box>
        <Box flex={["unset", null, 1]} minW={0} pos="relative" overflowX="visible">
          <Swiper
            lazy
            modules={[Pagination, Navigation]}
            navigation={{
              nextEl: `.reviews-navigation-next`,
              prevEl: `.reviews-navigation-prev`,
            }}
            pagination={{
              el: ".reviews-pagination",
              clickable: true,
            }}
            slidesPerView="auto"
            spaceBetween={16}
            centeredSlides={true}
            centeredSlidesBounds={true}
            breakpoints={{
              800: {
                slidesPerView: "auto",
                centeredSlides: false,
                centeredSlidesBounds: false,
              },
            }}
            style={{
              height: "359px",
              paddingLeft: isMedium ? 0 : "21px",
              paddingRight: isMedium ? 0 : "21px",
            }}
          >
            {reviews?.data?.map((review: any, idx: number) => (
              <SwiperSlide key={idx} className="no-flex">
                <ReviewsItem
                  review={review}
                  voted={voted}
                  handleVoteChange={(change: number) => submitVoteWithProductId(review?.id, review?.productId, change)}
                />
              </SwiperSlide>
            ))}
          </Swiper>
          <Box className="swiper-button-prev reviews-navigation-prev" left={["10px", null, -4]} />
          <Box className="swiper-button-next reviews-navigation-next" />
          <Box className="reviews-pagination" mt="24px" textAlign="center" />
        </Box>
      </Flex>
    </Box>
  )
}

export default memo(Reviews)
